var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYouTubeIcon = function SvgYouTubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.681 0.329597C14.3419 0.510956 14.8624 1.04533 15.039 1.72393C15.36 2.95382 15.36 5.52 15.36 5.52C15.36 5.52 15.36 8.08609 15.039 9.31607C14.8624 9.99467 14.3419 10.529 13.681 10.7105C12.4832 11.04 7.68 11.04 7.68 11.04C7.68 11.04 2.87677 11.04 1.67895 10.7105C1.01804 10.529 0.497542 9.99467 0.320902 9.31607C0 8.08609 0 5.52 0 5.52C0 5.52 0 2.95382 0.320902 1.72393C0.497542 1.04533 1.01804 0.510956 1.67895 0.329597C2.87677 0 7.68 0 7.68 0C7.68 0 12.4832 0 13.681 0.329597ZM6.23997 3.36023V8.16023L10.08 5.76033L6.23997 3.36023Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })));
};
export default SvgYouTubeIcon;